import { capitalizeWordsRemoveDash } from "../../../../utils/text.utils";

export default function Speficication({ speficicationData }) {

    if (!speficicationData.length) return null;

    return (<>
        <h2 className="tab-section-txt">SPECIFICATIONS:</h2>
        {speficicationData.map((item, index) => {
            return (
                <div className="section-txt-pdb" key={index}>
                    <strong>{capitalizeWordsRemoveDash(item.key)}:</strong>{" "}
                    <span className="sub-section-pdp">
                        {item.value}
                    </span>
                </div>
            );
        })}

    </>
    )
}
